<template>
  <div class="travelCategory">
    <div class="container" v-if="category">
      <div>
        <h1 class="h3 container-title">
          <router-link class="text-secondary" :to="{ name: 'TravelCategory' }">
            <i class="bi bi-arrow-left"></i>
            {{ category.name }}
          </router-link>
          - 子分類設定
        </h1>
        <div class="row justify-content-between">
          <nav aria-label="breadcrumb" class="col-auto">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">旅遊行程管理</li>
              <li class="breadcrumb-item">
                <router-link
                  class="text-secondary"
                  :to="{ name: 'TravelCategory' }"
                >
                  <span>分類設定</span>
                </router-link>
              </li>
              <li class="breadcrumb-item">{{ category.name }}</li>
              <li class="breadcrumb-item">子分類設定</li>
            </ol>
          </nav>
          <div class="col-12 col-sm text-end mb-3 mb-sm-0">
            <button
              type="button"
              class="btn btn-transparent"
              @click="showModal(null)"
            >
              新增子分類
            </button>
          </div>
        </div>
      </div>
      <div class="card mb-3 table-top-bar">
        <div class="card-body p-0">
          <div class="input-group">
            <span class="input-group-text d-none d-sm-block">
              顯示第
              {{ currentPage == 1 ? 1 : perPage * (currentPage - 1) + 1 }} 至
              {{
                currentPage == 1
                  ? totalRows > perPage
                    ? perPage
                    : totalRows
                  : perPage * (currentPage - 1) + perPage > totalRows
                  ? totalRows
                  : perPage * (currentPage - 1) + perPage
              }}
              項結果，共 {{ totalRows }} 項
            </span>
            <input
              v-model="filter"
              type="text"
              class="form-control"
              placeholder="搜尋"
            />
            <span class="input-group-text"><i class="bi bi-search"></i></span>
          </div>
        </div>
      </div>
      <div class="card mb-3">
        <div class="card-body">
          <b-table
            :responsive="windowWidth > breakpoints.sm"
            :stacked="windowWidth <= breakpoints.sm"
            borderless
            no-provider-filtering
            head-variant="light"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template v-slot:head()="scope">
              <div class="text-nowrap">
                {{ scope.label }}
              </div>
            </template>
            <template v-slot:cell(active)="data">
              <div class="d-flex flex-nowrap flex align-items-center">
                <button
                  @click="showModal(data.item.id)"
                  type="button"
                  class="btn btn-link px-1"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="編輯"
                >
                  <i class="bi bi-pencil mx-1 fs-5"></i>
                </button>
                <button
                  v-if="!data.item.itinerary_count"
                  @click="showDeleteModal(data.item.id, data.item.name)"
                  type="button"
                  class="btn btn-link px-1 text-danger"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="刪除"
                >
                  <i class="bi bi-trash me-2"></i>
                </button>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="d-block d-sm-none text-center mb-3">
        顯示第 {{ currentPage == 1 ? 1 : perPage * (currentPage - 1) + 1 }} 至
        {{
          currentPage == 1
            ? totalRows > perPage
              ? perPage
              : totalRows
            : perPage * (currentPage - 1) + perPage > totalRows
            ? totalRows
            : perPage * (currentPage - 1) + perPage
        }}
        項結果，共 {{ totalRows }} 項
      </div>
      <b-pagination
        v-if="totalRows > perPage"
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="right"
        first-number
        last-number
        class="mb-sm-0 mb-3 mt-sm-0 mt-3"
      ></b-pagination>
    </div>
    <div
      class="modal fade"
      id="travelCategoryModal"
      tabindex="-1"
      ref="travelCategoryModal"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content" v-if="modalDate">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ isEdit ? '編輯子分類' : '新增子分類' }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="save">
              <div class="mb-3">
                <label for="modalTitle" class="form-label required"
                  >子分類名稱</label
                >
                <input
                  v-model="modalDate.name"
                  type="text"
                  class="form-control"
                  id="modalTitle"
                  placeholder="請輸入"
                  required
                />
              </div>
              <div class="mb-3">
                <label for="modalStaticUri" class="form-label">自定網址</label>
                <input
                  v-model="modalDate.static_uri"
                  type="text"
                  class="form-control"
                  id="modalStaticUri"
                  placeholder="請輸入"
                  pattern="[0-9a-z\-_]+"
                />
                <div class="form-text">
                  只能用英文小寫、數字及'-'、'_'符號(非字首)，不可有空白 <br />
                  用於強化 SEO 搜尋
                </div>
              </div>
              <button ref="submit" type="submit" class="d-none"></button>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              取消
            </button>
            <button
              @click="$refs.submit.click()"
              type="button"
              class="btn btn-primary"
            >
              儲存
            </button>
          </div>
        </div>
      </div>
    </div>
    <DeleteModal
      name="行程子分類"
      :deleteItem="deleteItem"
      @confirmDelete="deleteEvent"
    />
  </div>
</template>

<script>
import { travel } from '@/http/api/travel.js'
import { mapState, mapGetters, mapMutations } from 'vuex'
import { Modal } from 'bootstrap'
import DeleteModal from '@/components/modal/DeleteModal.vue'

export default {
  name: 'TravelSubCategory',
  components: {
    DeleteModal
  },
  data () {
    return {
      bootstrap_modal: null,
      category: null,
      currentPage: 1,
      deleteItem: '',
      errMsg: null,
      errMsgKey: {
        name: '子分類名稱',
        static_uri: '自訂網址'
      },
      filter: null,
      filterOn: ['name', 'itinerary_count', 'static_uri'],
      fields: [
        {
          key: 'name',
          label: '子分類名稱',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'itinerary_count',
          label: '產品數量',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'static_uri',
          label: '自定網址',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'active',
          label: '功能',
          class: 'align-middle'
        }
      ],
      isEdit: false,
      items: null,
      modalID: null,
      modalDate: null
    }
  },
  computed: {
    ...mapState([
      'token',
      'windowWidth',
      'breakpoints',
      'perPage',
      'totalRows'
    ]),
    ...mapGetters(['errMsgInfo']),
    defaultModalDate () {
      const vm = this
      return {
        parent_id: vm.$route.params.id,
        name: null,
        static_uri: null
      }
    }
  },
  watch: {
    'token.headers.Authorization': function (data) {
      if (data) {
        this.initialEvent()
      }
    },
    currentPage () {
      this.$nextTick(() => this.InitBootstrapTooltip())
    },
    items () {
      this.$nextTick(() => this.InitBootstrapTooltip())
    },
    defaultModalDate (data) {
      this.modalDate = data
    }
  },
  methods: {
    ...mapMutations([
      'AlertsInfo',
      'Alerted',
      'InitBootstrapTooltip',
      'Loading',
      'Loaded',
      'SetTotalRows',
      'SetErrMsg',
      'SetErrMsgKey',
      'ToggleDeleteModal'
    ]),
    createCategory () {
      const vm = this
      travel
        .createCategory(vm.modalDate, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '創建資料成功'
            })
            vm.bootstrap_modal.hide()
            vm.getData()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    deleteEvent () {
      const vm = this
      travel
        .deleteCategory(vm.modalID, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '刪除資料成功'
            })
            vm.getData()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.ToggleDeleteModal(false)
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.ToggleDeleteModal(false)
          vm.Alerted()
          vm.Loaded()
        })
    },
    getData () {
      const vm = this
      const config = { ...vm.token }
      config.params = {
        parent_id: vm.$route.params.id
      }
      travel
        .getCategory('', config)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.items = data.data.sort((a, b) =>
              Date.parse(a.created_at).valueOf() >
              Date.parse(b.created_at).valueOf()
                ? -1
                : 1
            )
            vm.SetTotalRows(vm.items.length)
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
        })
    },
    getCategory () {
      const vm = this
      travel
        .getCategory(vm.$route.params.id, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.category = data.data
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
        })
    },
    initialEvent () {
      const vm = this
      vm.getData()
      vm.getCategory()
    },
    onFiltered (filteredItems) {
      const vm = this
      vm.SetTotalRows(filteredItems.length)
      vm.currentPage = 1
    },
    showModal (id) {
      const vm = this
      vm.bootstrap_modal = new Modal(vm.$refs.travelCategoryModal, {
        backdrop: 'static',
        keyboard: false
      })
      vm.modalID = id
      vm.isEdit = false
      if (!id) {
        vm.modalDate = JSON.parse(JSON.stringify(vm.defaultModalDate))
        vm.bootstrap_modal.show()
        return
      }
      vm.isEdit = true
      vm.Loading()
      travel
        .getCategory(id, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.modalDate = data.data
            vm.bootstrap_modal.show()
            vm.Loaded()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    showDeleteModal (id, title) {
      const vm = this
      vm.modalID = id
      vm.deleteItem = title
      vm.ToggleDeleteModal(true)
    },
    save () {
      const vm = this
      vm.Loading()
      if (vm.isEdit) {
        vm.updateCategory()
        return
      }
      vm.createCategory()
    },
    updateCategory () {
      const vm = this
      travel
        .updateCategory(vm.modalID, vm.modalDate, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '更新資料成功'
            })
            vm.bootstrap_modal.hide()
            vm.getData()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    }
  },
  created () {
    const vm = this
    vm.SetErrMsgKey(vm.errMsgKey)
  },
  mounted () {
    const vm = this
    if (vm.token.headers.Authorization) {
      vm.initialEvent()
    }
  }
}
</script>
